import {
  collection,
  onSnapshot,
  orderBy,
  query,
  type DocumentData,
  type Unsubscribe,
} from 'firebase/firestore';
import { useEffect, useState } from 'react';
import type { AreaReportSnapshot } from '@citizen-walk/shared-types';
import { db } from '../../lib/firebase';

export interface AreaReportSnapshotWithId extends AreaReportSnapshot {
  id: string;
}

export type AreaReportSnapshotsState =
  | { status: 'loading'; reports: AreaReportSnapshotWithId[]; error: null }
  | { status: 'ready'; reports: AreaReportSnapshotWithId[]; error: null }
  | { status: 'error'; reports: AreaReportSnapshotWithId[]; error: Error };

function mapSnapshotDoc(snap: { id: string; data: () => DocumentData }): AreaReportSnapshotWithId {
  return { ...(snap.data() as Omit<AreaReportSnapshot, 'id'>), id: snap.id };
}

/** 保存済みエリア選択集計スナップショットを作成日時降順で購読する (`useGisLayers` と同じパターン)。 */
export function useAreaReportSnapshots(districtId: string | null): AreaReportSnapshotsState {
  const [state, setState] = useState<AreaReportSnapshotsState>({
    status: 'loading',
    reports: [],
    error: null,
  });
  useEffect(() => {
    if (!districtId) return;
    const q = query(
      collection(db, 'districts', districtId, 'areaReports'),
      orderBy('createdAt', 'desc'),
    );
    const unsub: Unsubscribe = onSnapshot(
      q,
      (snap) => setState({ status: 'ready', reports: snap.docs.map(mapSnapshotDoc), error: null }),
      (error) => setState({ status: 'error', reports: [], error }),
    );
    return () => unsub();
  }, [districtId]);
  return state;
}
